var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
(function () {
  var t = {
      704: function _(t, e, o) {
        t.exports = o(79)("./src/core.js");
      },
      492: function _(t, e, o) {
        t.exports = o(79)("./src/engine.js");
      },
      181: function _(t, e, o) {
        t.exports = o(79)("./src/typing.js");
      },
      209: function _(t, e, o) {
        t.exports = o(79)("./src/utils.js");
      },
      79: function _(t) {
        "use strict";

        t.exports = CKEditor5.dll;
      }
    },
    e = {};
  function o(i) {
    var s = e[i];
    if (void 0 !== s) return s.exports;
    var n = e[i] = {
      exports: {}
    };
    return t[i](n, n.exports, o), n.exports;
  }
  o.d = function (t, e) {
    for (var i in e) {
      o.o(e, i) && !o.o(t, i) && Object.defineProperty(t, i, {
        enumerable: !0,
        get: e[i]
      });
    }
  }, o.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, o.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  };
  var i = {};
  (function () {
    "use strict";

    o.r(i), o.d(i, {
      Autoformat: function Autoformat() {
        return c;
      }
    });
    var t = o(704),
      e = o(181),
      s = o(492),
      n = o(209);
    function r(t, e, o, i) {
      var r,
        d = null;
      "function" == typeof i ? r = i : (d = t.commands.get(i), r = function r() {
        t.execute(i);
      }), t.model.document.on("change:data", function (a, c) {
        if (d && !d.isEnabled || !e.isEnabled) return;
        var l = (0, n.first)(t.model.document.selection.getRanges());
        if (!l.isCollapsed) return;
        if (c.isUndo || !c.isLocal) return;
        var u = Array.from(t.model.document.differ.getChanges()),
          h = u[0];
        if (1 != u.length || "insert" !== h.type || "$text" != h.name || 1 != h.length) return;
        var g = h.position.parent;
        if (g.is("element", "codeBlock")) return;
        if (g.is("element", "listItem") && "function" != typeof i && !["numberedList", "bulletedList", "todoList"].includes(i)) return;
        if (d && !0 === d.value) return;
        var m = g.getChild(0),
          f = t.model.createRangeOn(m);
        if (!f.containsRange(l) && !l.end.isEqual(f.end)) return;
        var p = o.exec(m.data.substr(0, l.end.offset));
        p && t.model.enqueueChange(function (e) {
          var o = e.createPositionAt(g, 0),
            i = e.createPositionAt(g, p[0].length),
            n = new s.LiveRange(o, i);
          if (!1 !== r({
            match: p
          })) {
            e.remove(n);
            var _o = t.model.document.selection.getFirstRange(),
              _i = e.createRangeIn(g);
            !g.isEmpty || _i.isEqual(_o) || _i.containsRange(_o, !0) || e.remove(g);
          }
          n.detach(), t.model.enqueueChange(function () {
            t.plugins.get("Delete").requestUndoOnBackspace();
          });
        });
      });
    }
    function d(t, e, o, i) {
      var s, n;
      o instanceof RegExp ? s = o : n = o, n = n || function (t) {
        var e;
        var o = [],
          i = [];
        for (; null !== (e = s.exec(t)) && !(e && e.length < 4);) {
          var _e = e,
            _t = _e.index,
            _s = _e[1],
            _n = _e[2],
            _r = _e[3];
          var _d = _s + _n + _r;
          _t += e[0].length - _d.length;
          var _a = [_t, _t + _s.length],
            _c = [_t + _s.length + _n.length, _t + _s.length + _n.length + _r.length];
          o.push(_a), o.push(_c), i.push([_t + _s.length, _t + _s.length + _n.length]);
        }
        return {
          remove: o,
          format: i
        };
      }, t.model.document.on("change:data", function (o, s) {
        if (s.isUndo || !s.isLocal || !e.isEnabled) return;
        var r = t.model,
          d = r.document.selection;
        if (!d.isCollapsed) return;
        var c = Array.from(r.document.differ.getChanges()),
          l = c[0];
        if (1 != c.length || "insert" !== l.type || "$text" != l.name || 1 != l.length) return;
        var u = d.focus,
          h = u.parent,
          _ref = function (t, e) {
            var o = t.start;
            return {
              text: Array.from(t.getItems()).reduce(function (t, i) {
                return !i.is("$text") && !i.is("$textProxy") || i.getAttribute("code") ? (o = e.createPositionAfter(i), "") : t + i.data;
              }, ""),
              range: e.createRange(o, t.end)
            };
          }(r.createRange(r.createPositionAt(h, 0), u), r),
          g = _ref.text,
          m = _ref.range,
          f = n(g),
          p = a(m.start, f.format, r),
          x = a(m.start, f.remove, r);
        p.length && x.length && r.enqueueChange(function (e) {
          if (!1 !== i(e, p)) {
            var _iterator = _createForOfIteratorHelper(x.reverse()),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var _t2 = _step.value;
                e.remove(_t2);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
            r.enqueueChange(function () {
              t.plugins.get("Delete").requestUndoOnBackspace();
            });
          }
        });
      });
    }
    function a(t, e, o) {
      return e.filter(function (t) {
        return void 0 !== t[0] && void 0 !== t[1];
      }).map(function (e) {
        return o.createRange(t.getShiftedBy(e[0]), t.getShiftedBy(e[1]));
      });
    }
    var c = /*#__PURE__*/function (_t$Plugin) {
      _inherits(c, _t$Plugin);
      function c() {
        _classCallCheck(this, c);
        return _possibleConstructorReturn(this, _getPrototypeOf(c).apply(this, arguments));
      }
      _createClass(c, [{
        key: "afterInit",
        value: function afterInit() {
          this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
        }
      }, {
        key: "_addListAutoformats",
        value: function _addListAutoformats() {
          var _this = this;
          var t = this.editor.commands;
          t.get("bulletedList") && r(this.editor, this, /^[*-]\s$/, "bulletedList"), t.get("numberedList") && r(this.editor, this, /^1[.|)]\s$/, "numberedList"), t.get("todoList") && r(this.editor, this, /^\[\s?\]\s$/, "todoList"), t.get("checkTodoList") && r(this.editor, this, /^\[\s?x\s?\]\s$/, function () {
            _this.editor.execute("todoList"), _this.editor.execute("checkTodoList");
          });
        }
      }, {
        key: "_addBasicStylesAutoformats",
        value: function _addBasicStylesAutoformats() {
          var t = this.editor.commands;
          if (t.get("bold")) {
            var _t3 = l(this.editor, "bold");
            d(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, _t3), d(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, _t3);
          }
          if (t.get("italic")) {
            var _t4 = l(this.editor, "italic");
            d(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, _t4), d(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, _t4);
          }
          if (t.get("code")) {
            var _t5 = l(this.editor, "code");
            d(this.editor, this, /(`)([^`]+)(`)$/g, _t5);
          }
          if (t.get("strikethrough")) {
            var _t6 = l(this.editor, "strikethrough");
            d(this.editor, this, /(~~)([^~]+)(~~)$/g, _t6);
          }
        }
      }, {
        key: "_addHeadingAutoformats",
        value: function _addHeadingAutoformats() {
          var _this2 = this;
          var t = this.editor.commands.get("heading");
          t && t.modelElements.filter(function (t) {
            return t.match(/^heading[1-6]$/);
          }).forEach(function (e) {
            var o = e[7],
              i = new RegExp("^(#{".concat(o, "})\\s$"));
            r(_this2.editor, _this2, i, function () {
              if (!t.isEnabled || t.value === e) return !1;
              _this2.editor.execute("heading", {
                value: e
              });
            });
          });
        }
      }, {
        key: "_addBlockQuoteAutoformats",
        value: function _addBlockQuoteAutoformats() {
          this.editor.commands.get("blockQuote") && r(this.editor, this, /^>\s$/, "blockQuote");
        }
      }, {
        key: "_addCodeBlockAutoformats",
        value: function _addCodeBlockAutoformats() {
          var _this3 = this;
          var t = this.editor,
            e = t.model.document.selection;
          t.commands.get("codeBlock") && r(t, this, /^```$/, function () {
            if (e.getFirstPosition().parent.is("element", "listItem")) return !1;
            _this3.editor.execute("codeBlock", {
              usePreviousLanguageChoice: !0
            });
          });
        }
      }, {
        key: "_addHorizontalLineAutoformats",
        value: function _addHorizontalLineAutoformats() {
          this.editor.commands.get("horizontalLine") && r(this.editor, this, /^---$/, "horizontalLine");
        }
      }], [{
        key: "requires",
        get: function get() {
          return [e.Delete];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "Autoformat";
        }
      }]);
      return c;
    }(t.Plugin);
    function l(t, e) {
      return function (o, i) {
        if (!t.commands.get(e).isEnabled) return !1;
        var s = t.model.schema.getValidRanges(i, e);
        var _iterator2 = _createForOfIteratorHelper(s),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t7 = _step2.value;
            o.setAttribute(e, !0, _t7);
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        o.removeSelectionAttribute(e);
      };
    }
  })(), (window.CKEditor5 = window.CKEditor5 || {}).autoformat = i;
})();